module.exports = __webpack_public_path__ + "media/application/images/ui/badge-peoples-choice-with-text-b37a21e320f4efc7ed06cf172be4fa75.png";